<template>
  <div>
    <section>
        <div class="container">
            <figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
        </div>
    </section>
    <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li><a href="/store">聯盟店家</a></li>
                <li class="active">店家列表</li>
            </ol>
            <div class="row">
              <center>
                <form class="navbar-form" @submit.prevent>
                    <div class="form-group">
                        <input type="text" v-model="keyword" class="form-control" placeholder="請輸入商家名稱">
                    </div>
                    <button type="button" @click="SearchingStore()" class="btn btn-success">查詢</button>
                </form>
              </center>
            </div>
            <div class="row">
                <div class="col-md-3 col-sm-4 col-xs-6" v-for="(row, index) in companies">
                    <div class="store_list">
                        <div class="store_box">
                            <router-link :to="'/store/'+row.comid">
                                <figure class='pic justify'>
                                    <img :src="'https://files.i80.com.tw/images/product/'+row.com_image" class="img-responsive"/>
                                </figure>
                                <h5 class="title">{{row.com_name}}</h5>
                                <p class="txt">{{row.county_name}}{{row.district_name}}{{row.com_address}}</p>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <nav aria-label="...">
                <ul class="pagination">
                    <li class="disabled">
                        <a href="#" aria-label="Previous">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    <li class="active"><a href="#">1 <span class="sr-only">(current)</span></a></li>
                    <li class="disabled">
                        <a href="#" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'Store',
  data () {
    return {
      storeData: '',
      keyword: '',
      companies: [],
      origincompanies: []
    }
  },
  mounted: function () {
    let stories = JSON.parse(localStorage.getItem('companies'))
    this.companies = stories
    this.origincompanies = stories
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    SearchingStore () {
      let keyword = this.keyword
      if (keyword !== '') {
        this.companies = this.origincompanies.filter(function (value) {
          return value.com_name.indexOf(keyword) >= 0
        })
      } else {
        this.companies = this.origincompanies
      }
    }
  },
  computed: {
    ...mapGetters({
      userID: 'getUserID'
    })
  },
  metaInfo: {
    title: '愛幫您-聯盟店家',
    meta: [{
      name: '愛幫您-聯盟店家',
      content: '這邊擁有最多元的聯盟店家選擇，且都經過平台層層把關。'
    }],
    link: [{
      rel: 'store',
      href: 'https://www.i80.com.tw/store'
    }]
  }
}
</script>



// WEBPACK FOOTER //
// Store.vue?4514d900